var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uva-page4 pt80"},[_c('div',{staticClass:"img-div",class:'order-' + _vm.imgOrder},[_vm._t("img")],2),_c('div',{staticClass:"text-div"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }